import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type UpdateMediaPackageBody, updateMediaPackage } from '~/services/MediaService';

import { mediaPackageQueryKeys } from './mediaQueryKeys';

/** Saves changes to one media package, including which assets it bundles. */
export function useUpdateMediaPackage(mediaPackageId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: UpdateMediaPackageBody) => updateMediaPackage(mediaPackageId, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: mediaPackageQueryKeys.all }),
  });
}
